// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/.store/css-loader@0.27.3/node_modules/css-loader/index.js?minimize!../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b4b68e54\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Demo.vue");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/.store/vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("4629b847", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-style-loader@4.1.3/~/vue-style-loader!./~/.store/css-loader@0.27.3/~/css-loader?minimize!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b4b68e54","scoped":true,"hasInlineConfig":false}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Demo.vue
// module id = 190
// module chunks = 1